<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import ProductionModal from '@/components/productions/production-modal.vue';
import LocationCompanyModal from '@/components/front/location-company-modal.vue';
import api from '@/helpers/api-rest/api.js';


export default {
  page: {
    title: "Productoras",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, ProductionModal, LocationCompanyModal },
  data() {
    return {
      tableData: [],
      title: "Productoras",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        { key: "id", sortable: true, label: "ID" },
        { key: "name", sortable: true, label: "Nombre" },
        // { key: "address", sortable: true, label: "Dirección" },
        { key: "company_type.name", sortable: true, label: "Tipo de compañía" },
        { key: "installed_potency", sortable: true, label: "Potencia instalada (MW)" },
        { key: "unit_potency", sortable: true, label: "Potencia/Unidad (kW)" },
        { key: "elements_quantity", sortable: true, label: "Elementos" },
        { key: "park", sortable: true, label: "Parque" },
        { key: "action", tdClass:"custom-table-action", sortable: false, label: "" }
        //{ key: "status", sortable: false, label: "Estado" }
      ],
      showProductionModal: false,
      showLocationCompanyModal: false,
      editMode: false,
      productionEdit: undefined,
      switchStatus: false,
      companyPosition: null
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    }
  },
  methods: {
    loadDataFromApi(){
      //const apiHost = process.env.VUE_APP_API_HOST;
      const apiEndpoint = `/api/v1/production-companies`;
      api.get({url:apiEndpoint})
      //axios.get(apiEndpoint)
        .then(response => {
          //console.log(response);
          this.tableData = response.data;
          this.tableData.forEach(production => {
            production.switchStatus = production.status === true;
            //console.log(this.companyPosition);
          });

        })
        .catch(error => {
          console.error("Error loading data:", error);
        });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    success(production) {
      if (this.productionEdit) {
        this.productionEdit = production;
      }else{
        this.tableData.push(production);
        production.switchStatus = production.status === true;
      }


    },
    addProduction() {
      this.productionEdit = undefined;
    },
    editProduction(production) {
      this.productionEdit = production;
    },
    loadDataCompanyType(companyTypeId){
      const apiEndpoint = `/api/v1/company-types/${companyTypeId}`;
      api.get({url:apiEndpoint})
      .then(response => {
        console.log(response);
        //this.company_types = response.data;
      })
      .catch(error => {
        console.error("Error loading data:", error);
      });
    },
    toggleStatus(production){
      //const apiHost = process.env.VUE_APP_API_HOST;
      const apiEndpoint = `/api/v1/production-companies/change-status/${production.id}?_method=PATCH`;
      api.post({url:apiEndpoint})
      //axios.post(apiEndpoint)
        .then(response => {
          production.status = response.data.status;
          production.switchStatus = production.status === true;
        })
        .catch(error => {
          console.error("Error loading data:", error);
        });
    },
    handleSwitchInput(production) {
      this.toggleStatus(production);
    },
    showCompanyMap(production){
      this.showLocationCompanyModal = true;
      this.companyPosition = {lat: parseFloat(production.latitude), lng: parseFloat(production.longitude), nombre: production.name};
    }
  },
  mounted() {
    this.loadDataFromApi();
    // Set the initial number of items
    this.totalRows = this.tableData.length;
    //console.log(this.fields);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title">
      <template v-slot:header-button>
        <button v-b-modal.ModalProduction @click="addProduction()" class="btn btn-primary">
          <i class="fa fa-plus"></i> Añadir Productora
        </button>
      </template>
    </PageHeader>
    <production-modal :show-production-modal="showProductionModal" :production="productionEdit" @success="success" />
    <LocationCompanyModal :showLocationCompanyModal="showLocationCompanyModal" :myPosition="companyPosition" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- <h4 class="card-title">Data Table</h4> -->
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;registros
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    <!-- Buscar: -->
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Buscar..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
              <template v-slot:cell(action)="row">
                <div>
                  <a href="javascript:void(0);" class="mr-3 text-primary" v-b-modal.ModalProduction title="Edit" @click="editProduction(row.item)">
                    <i class="mdi mdi-pencil font-size-18"></i>
                  </a>
                  <a href="javascript:void(0);" class="mr-3 text-primary" v-b-modal.ModalMapCompnay title="Map" @click="showCompanyMap(row.item)">
                    <i class="mdi mdi-map-marker-radius font-size-18"></i>
                  </a>
                  <!-- <switches
                    v-model="row.item.status"
                    type-bold="false"
                    color="primary"
                    class="ml-1 mb-0"
                    ref="switch"
                    @click.native="handleSwitchInput(row.item)"
                  /> -->
                  <b-form-checkbox
                      v-model="row.item.status"
                      switch class="mb-1"
                      value="1"
                      @change="handleSwitchInput(row.item)"
                    ></b-form-checkbox>
                </div>
              </template>

              <!-- <template v-slot:cell(status)="row">
                <switches
                  v-model="row.item.status"
                  type-bold="false"
                  color="primary"
                  class="ml-1 mb-0"
                  ref="switch"
                  @click.native="handleSwitchInput(row.item)"
                />
              </template> -->

            </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>